import { useTranslation } from 'react-i18next'

import Text from '../../../Text'

import * as styles from './BirdviewChartGridEmpty.module.css'

function BirdviewChartGridEmpty({ children }) {
  const { t } = useTranslation()

  return (
    <div className={styles.empty}>
      <Text className={styles.title}>
        {t('DashboardBirdview.ChartsEmptyStateTitleKey')}
      </Text>
      <Text isSecondary className={styles.hint}>
        {t('DashboardBirdview.ChartsEmptyStateHintKey')}
      </Text>
      {children}
    </div>
  )
}

export default BirdviewChartGridEmpty
